import type { FilingsWidgetActions } from 'src/store/actions/widgets/filings';
import type { FilingsWidgetViewModel, WidgetTabViewModel } from 'src/store/types';

export const fillingsReducer = (
    state: WidgetTabViewModel<FilingsWidgetViewModel>,
    action: FilingsWidgetActions,
): WidgetTabViewModel<FilingsWidgetViewModel> => {
    switch (action.type) {
        case 'userSetFilingsUniverse': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    universeId: typeof action.universe === 'string' ? action.universe : (action.universe?.id ?? null),
                },
            };
        }

        case 'userSetFilingsSymbolFilter': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    symbolFilter: action.symbolFilter,
                },
            };
        }

        case 'updateFillingsSymbolFilter': {
            return {
                ...state,
                widget: { ...state.widget, symbolFilter: action.symbol },
            };
        }

        case 'userSetFilingsGoToDate': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    gotoDate: action.date,
                },
            };
        }

        case 'userSetFilingsSymbolRetention': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    symbolRetention: action.symbolRetention,
                },
            };
        }

        case 'userSetFilingsFilingTypes': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    filingTypes: action.filingTypes,
                },
            };
        }

        default:
            return state;
    }
};
